export default __webpack_public_path__ + "7b4e417.png";